// extracted by mini-css-extract-plugin
export default {"select":"Dropdown_select__dMqjB","icon":"Dropdown_icon__cZx5z"};